<template>
  <div>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">Edit Announcement</p>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <router-link
              :to="{ name: 'announcementList' }"
              class="button is-info is-small btnicon"
              title="Back To List"
            >
              Back To List
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <section class="container section is-main-section">
      <form @submit.prevent="save">
        <div>
          <div class="columns row">
            <div class="column is-4">
              <div class="field">
                <label class="label">
                  Type<span class="has-text-danger">*</span>
                </label>
                <div class="control select is-fullwidth">
                  <select name="type" required v-model="type">
                    <option disabled value>--Select--</option>
                    <option
                      :value="type.id"
                      v-for="type in typeData"
                      :key="type.id"
                      :v-bind="type.id"
                    >
                      {{ type.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column is-4">
              <div class="field">
                <label class="label">
                  Title <span class="has-text-danger">*</span></label
                >
                <div class="control">
                  <input class="input" v-model="title" required type="text" />
                </div>
              </div>
            </div>
          </div>
          <div class="columns row" style="width: 100%">
            <div class="columns form-row" style="width: 100%">
              <div class="column is-12">
                <div class="field">
                  <label class="label">
                    Description
                    <span class="requir has-text-danger">*</span></label
                  >
                  <!-- <ckeditor v-model="discription" ref="ckeditorRef"></ckeditor> -->
                  <!-- <textarea class="input" rows="3" required clearable v-model="discription" ref="ckeditorRef"></textarea> -->
                  <quill-editor
                    v-model="discription"
                    theme="snow"
                    ref="myQuillEditor"
                  >
                  </quill-editor>
                </div>
              </div>
            </div>
          </div>
          <div class="columns form-row">
            <div class="column">
              <div class="field">
                <label class="label"> select file </label>
                <b-field class="file is-primary">
                  <b-upload
                    @input="onFilechange()"
                    v-model="dropFile"
                    multiple
                    class="file-label"
                  >
                    <span class="file-cta">
                      <b-icon class="file-icon" icon="upload"></b-icon>
                      <span class="file-label">Click to upload</span>
                    </span>
                  </b-upload>
                </b-field>
                <span class="has-text-danger"
                  >Allowed files: .gif, .png, .jpg, .jpeg, .xlsx, .xls, .csv,
                  .doc, .pdf, .txt, .docx, .pptx, .pptm, .ppt, .xps,
                  .potx,.potm, .pot, thmx, .ppsx, .pps, .ppam, .ppa, .mp3, .wma,
                  .aac, .wav, .flac, .mp4, .avi, .m4p, .m4v, .wmv, .mov, .webm,
                  .mpg, .mp2, .mpeg, .mpe, .mpv, .ogg, .flv, .mkv
                </span>

                <br /><br />
                <span class="has-text-danger"
                  >File's that are not supported will be removed
                  automatically!</span
                >

                <span v-if="dropFile.length > 0">
                  <div class="tags" v-for="(file, i) in dropFile" :key="i">
                    <span class="tag is-primary">
                      {{ file.name }}
                    </span>
                    <button
                      class="delete is-small"
                      type="button"
                      @click="deleteDropFile(i)"
                    ></button>
                  </div>
                </span>
              </div>
            </div>
            <button
              class="button is-success"
              :disabled="hasClicked"
              type="submit"
              style="margin-right: 800px; margin-top: 36px"
            >
              Save
            </button>
          </div>
        </div>
        <div></div>
      </form>
      <span v-if="dropFile1.length > 0">
        <span style="margin-top: 50px" class="has-text-primary"
          >Already Uploaded Documents</span
        >
        <div class="tags" v-for="(file, i) in dropFile1" :key="i">
          <div @click="download(file.urlPath)" class="tag is-primary">
            {{ file.name }}
          </div>

          <button
            class="delete is-small"
            type="button"
            @click="deleteDropFile1(file.id)"
          ></button>
        </div>
      </span>
    </section>
  </div>
</template>
<script>
import constants from '@/utils/constants'

import Utils from '@/utils'
// import Vue from 'vue'
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
// import CKEditor from 'ckeditor4-vue'
// Vue.use(CKEditor)
export default {
  name: 'editAnnouncement',
  props: ['announcementID'],
  components: {
    quillEditor
  },
  data () {
    return {
      total: 0,
      dropFile: [],
      discription: '',
      type: '',
      title: '',
      typeData: [],
      annonceData: [],
      hasClicked: false,
      loader: true,
      sendData: {},
      selectedfranchiseeID: [],
      dropFile1: [],
      documentData: [],
      isWrite: false,
      deleteFileIdArr: [],
      allowedFiles: [
        'gif',
        'png',
        'jpg',
        'jpeg',
        'xlsx',
        'xls',
        'csv',
        'doc',
        'pdf',
        'txt',
        'docx',
        'pptx',
        'pptm',
        'ppt',
        'xps',
        'potx',
        'potm',
        'pot',
        'thmx',
        'ppsx',
        'pps',
        'ppam',
        'ppa',
        'mp3',
        'wma',
        'aac',
        'wav',
        'flac',
        'mp4',
        'avi',
        'm4p',
        'm4v',
        'wmv',
        'mov',
        'webm',
        'mpg',
        'mp2',
        'mpeg',
        'mpe',
        'mpv',
        'ogg',
        'flv',
        'mkv'
      ]
    }
  },

  async created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.announcement()
    await this.gettype()
    await this.announcementDocuments()
  },
  beforeRouteLeave (to, from, next) {
    // Ckeditor maximize fix and Alert on unsaved changes
    // const that = this.$refs.ckeditorRef
    // const maximizedState = that.instance.getCommand('maximize').state
    // if (maximizedState === 1) { that.instance.execCommand('maximize') }
    // if (this.hasDataChanged() && !this.hasClicked) {
    //   return this.$buefy.dialog.confirm({
    //     title: 'Leave Page',
    //     message: 'Do you really want to leave? you have unsaved changes!',
    //     type: 'is-danger',
    //     cancelText: 'No',
    //     confirmText: 'Yes',
    //     onConfirm: () => { next() },
    //     onCancel: () => { next(false) }
    //   })
    // } else
    next()
  },
  beforeMount () {
    window.addEventListener('beforeunload', this.preventNav)
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.preventNav)
  },
  methods: {
    preventNav (event) {
      if (!this.hasDataChanged()) return
      event.preventDefault()
      event.returnValue = ''
    },
    hasDataChanged () {
      const prevTitle = this.annonceData.title
      const prevDescription = this.annonceData.descriptions
      const prevType = this.annonceData.typeID
      const boolAlert =
        this.discription !== prevDescription ||
        this.dropFile.length > 0 ||
        this.title !== prevTitle ||
        this.type !== prevType
      return boolAlert
    },
    announcement: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(
          `${constants.API_URL}/api/communication/announcements/${this.announcementID}`
        )
        this.annonceData = data
        this.type = this.annonceData.typeID
        this.title = this.annonceData.title
        this.discription = this.annonceData.descriptions
        // this.dropFile1 = this.annonceData.announcementDocumentMaps
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    announcementDocuments: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(
          `${constants.API_URL}/api/communication/announcements/${this.announcementID}`
        )
        this.documentData = data
        this.dropFile1 = this.documentData.announcementDocumentMaps
        if (this.dropFile1) {
          this.dropFile1.forEach((docID) => {
            docID.name = docID.urlKey.substring(
              docID.urlKey.lastIndexOf('/') + 1
            )
          })
        }
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    deleteDropFile (i) {
      this.dropFile.splice(i, 1)
    },
    deleteDropFile1 (docID) {
      this.$buefy.dialog.confirm({
        title: 'Deleting Image',
        message: '"Do you want to Delete this file"?',
        confirmText: 'Delete Image',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.dropFile1.forEach((element) => {
            if (docID === element.id) {
              var index = this.dropFile1.indexOf(element)
              if (index !== -1) {
                this.dropFile1.splice(index, 1)
              }
              this.deleteFileIdArr.push(docID)
            }
          })
        }
      })
    },

    gettype: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(
          `${constants.API_URL}/api/communication/announcements/type`
        )
        this.typeData = data
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },

    save: async function () {
      let discriptionTest = this.discription
      discriptionTest = discriptionTest.replace(/(<([^>]+)>)/gi, '')
      discriptionTest = discriptionTest.replace(/&nbsp;/g, '')
      discriptionTest = discriptionTest.trim()
      if (discriptionTest === '' || discriptionTest === null) {
        return this.$buefy.toast.open({
          message: 'Please fill Description',
          type: 'is-danger',
          duration: 4000
        })
      }
      if (this.deleteFileIdArr.length > 0) {
        this.deleteFileIdArr.forEach((docID) => {
          this.deleteDocument(docID)
        })
      }
      let formData = new FormData()
      formData.append('typeID', this.type)
      formData.append('title', this.title)
      formData.append('descriptions', this.discription)
      for (let i = 0; i < this.dropFile.length; i++) {
        formData.append('file', this.dropFile[i])
      }
      // for (var pair of formData.entries()) {
      //   console.log(pair)
      // }
      this.hasClicked = true
      try {
        await http.put(
          `${constants.API_URL}/api/communication/announcements/${this.announcementID}`,
          formData
        )
        this.loader = false
        this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Saved successfully',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
        return this.$router.push({ name: 'announcementList' })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While Details', errorMessage)
        this.lock = false
        this.hasClicked = false
        this.loader = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    download: async function (i) {
      try {
        let url = await http.get(
          `${constants.API_URL}/api/staff/downloadurl?s3urlKey=${i}`
        )
        window.open(url.data)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting file details, ${errorMessage}`)
      }
    },
    deleteDocument: async function (deldocID) {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        await http.get(
          `${constants.API_URL}/api/communication/announcements/document/status/${deldocID}`
        )
        this.loadingComponent.close()
        // this.announcementDocuments()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    onFilechange () {
      let r = this.dropFile.filter((a, i) => {
        if (this.allowedFiles.includes(a.name.split('.').pop())) {
        }
        return this.allowedFiles.includes(a.name.split('.').pop())
      })
      this.dropFile = r
    }
  }
}
</script>
<style scoped>
textarea {
  background-color: #ffffff;
  border-color: #dbdbdb;
  border-radius: 4px;
  color: #363636;
  height: 9.5rem;
}
</style>
